import * as Yup from "yup";

interface IVehicle extends Yup.MixedSchema {
  description: string;
  registrationNo: string;
  estimatedValue: string;
  valuationAmount: string;
}

const VehicleSchema = Yup.object<IVehicle>().shape({
  description: Yup.string().required(
    "US.COLLECTION.VALIDATIONS:REQUIRED.DESCRIPTION_IS_REQUIRED"
  ),
  registrationNo: Yup.string().required(
    "US.COLLECTION.VALIDATIONS:REQUIRED.REGISTRATION_NO_IS_REQUIRED"
  ),
  estimatedValue: Yup.string()
  .test(
    "estimatedValue",
    "US.COLLECTION.VALIDATIONS:REQUIRED.ESTIMATED_VALUE_MUST_BE_POSITIVE",
    (val: any) => {
      return val >= 0;
    }
  ),
  valuationAmount: Yup.string()
  .test(
    "valuationAmount",
    "US.COLLECTION.VALIDATIONS:REQUIRED.VALUATION_AMOUNT_MUST_BE_POSITIVE",
    (val: any) => {
      return val >= 0;
    }
  ),
});

export default VehicleSchema;
